import _ from 'lodash';
import Cookies from 'cookies-js';

import config from '../config';
import { resolve } from './LinkMapper';

const CookieHelper = {
    MAX_COOKIE_CHARS: 3800, // Keep well below common 4KB cookie limits (Base64 adds ~33%)

    getNamespacedCookie (name) {
        const namespace = config.get('namespace');
        return namespace ? `${namespace}-${name}` : name;
    },

    set (cookieName, value, attributes = {}, needToStringify = true) {
        const cookieDomain = config.get('cookieDomain');
        const domain = cookieDomain.find((d) => window.location.hostname.endsWith(d));
        attributes = {
            domain,
            secure: true,
            ...attributes
        };
        Cookies.set(
            this.getNamespacedCookie(cookieName),
            needToStringify ? JSON.stringify(value) : value,
            attributes
        );
    },

    get (cookieName, shouldDecode) {
        try {
            const value = Cookies.get(this.getNamespacedCookie(cookieName));
            if (_.isString(value)) {
                if (shouldDecode) {
                    return JSON.parse((atob(value)));
                }
                return JSON.parse(value);
            } else {
                return value;
            }
        } catch (error) {
            console.error(error);
            return null;
        }
    },

    clear(cookieName) {
        const cookieDomain = config.get('cookieDomain');
        const domain = cookieDomain.find((d) => window.location.hostname.endsWith(d));
        Cookies.expire(this.getNamespacedCookie(cookieName), { domain });
    },

    objectFromCookie(cookieName, type) {
        const value = this.get(cookieName);
        if (type && type.fromJSON) {
            return resolve(value).as(type);
        } else if (type) {
            return resolve(value).with(type);
        } else {
            return value;
        }
    },

    objectToCookie(cookieName, value, expires) {
        this.set(cookieName, value, { expires });
    }

};

export default CookieHelper;
